import { BottomSheet, Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { DialogContent, Stack, ThemeProvider } from "@mui/material";

import { BottomSheetHeader } from "../components/BottomSheetHeader";
import { Button } from "../components/Button";
import { DialogFooter } from "../components/DialogFooter";
import { TextButton } from "../components/TextButton";

interface SignICAgreementBottomSheetProps {
  readonly modalState: UseModalState;
  readonly onDismiss: () => void;
  readonly onContinue: () => void;
}

export function SignICAgreementBottomSheet(props: SignICAgreementBottomSheetProps) {
  const { modalState, onDismiss, onContinue } = props;

  return (
    <ThemeProvider theme={getTheme()}>
      <BottomSheet
        modalState={modalState}
        header={<BottomSheetHeader onClose={onDismiss} />}
        footer={
          <DialogFooter orientation="vertical">
            <Button fullWidth size="large" variant="contained" onClick={onContinue}>
              Continue
            </Button>
            <TextButton size="large" sx={{ marginTop: 1, fontWeight: "bold" }} onClick={onDismiss}>
              Dismiss
            </TextButton>
          </DialogFooter>
        }
      >
        <DialogContent>
          <Stack spacing={7}>
            <Title component="h2" textAlign="center">
              We&apos;ve updated our Independent Contractor Agreement
            </Title>
            <Text>
              You will be asked to verify your phone number and accept our updated Independent
              Contractor agreement, which governs your access to Clipboard&apos;s technology
              platform and applications.
            </Text>
          </Stack>
        </DialogContent>
      </BottomSheet>
    </ThemeProvider>
  );
}
